import { CardContent as MuiCardContent, type CardContentProps as MuiCardContentProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<MuiCardContentProps>;

export function CardContent(props: Props) {
  return <MuiCardContent {...props} />;
}

export type { Props as CardContentProps };
